import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';

import { useAuth } from '../hooks/useAuth';
import { PermissionsEnum } from '../pokCore/authorization/permissions';
import { useTooltipDisplay } from '../pokCore/TooltipDisplayProvider';
import { TooltipKey } from '../pokCore/tooltip.enum';

interface LabelWithTooltipProps {
  label: React.ReactNode;
  tooltipKey: TooltipKey;
  placement?: 'top' | 'right' | 'bottom' | 'left';
  size?: 'wide';
}

export const LabelWithTooltip: React.FC<LabelWithTooltipProps> = ({
  label,
  tooltipKey,
  placement = 'right',
  size,
}) => {
  const { getTextByKey } = useTooltipDisplay();
  const auth = useAuth();
  const isAdmin = auth.check(PermissionsEnum.Administration);
  const baseText = tooltipKey ? getTextByKey(tooltipKey) : '';
  const tooltipText =
    tooltipKey && isAdmin
      ? `${baseText}<br><em>(${tooltipKey})</em>`
      : baseText;

  if (!baseText) {
    return <>{label}</>;
  }

  return (
    <>
      {label}
      <OverlayTrigger
        placement={placement}
        overlay={
          <Tooltip className={size === 'wide' ? 'tooltip-wide' : undefined}>
            <span dangerouslySetInnerHTML={{ __html: tooltipText }} />
          </Tooltip>
        }
      >
        <span className="ms-2" style={{ cursor: 'help' }}>
          <Icon.InfoCircle size={16} />
        </span>
      </OverlayTrigger>
    </>
  );
};
